import React, { Component } from 'react';
import { Form, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import { Redirect } from "react-router-dom";
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import { cloneDeep, isEmpty } from 'lodash';
import "./index.css";

class AddWhitelist extends Component {
	constructor(props) {
		super(props);
		let sitePath;
		let filePath;
        this.wlistFileInput = React.createRef();
		
		const protocol = window.location.protocol;
		const slashes = protocol.concat("//");
		sitePath = slashes.concat(window.location.hostname);
		this.state = {
			userId: props.app.userId,
			apiPath: props.app.apiPath,
			sitePath: sitePath,
			filePath: filePath,
			whitelistAdded: false,
			mobile: '',
            formatType : '1',
			wlistFileInput: this.wlistFileInput,
		}

	}

	componentDidMount() {

	}

	toggleChange = (e, name) => {
		this.setState({
			[name]: !this.state[name],
		});
	}


	setvalue = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	setMessageShow = (status) => {
		this.setState({
		});
	}

	// Add Plan
	handleAddVoiceWhitelist = (event) => {
		event.preventDefault();
		const formData = cloneDeep(this.state);
		console.log(formData);

		if(this.state.formatType === "1"){
		   const data = {
			"userId": formData.userId,
			"mobile": formData.mobile,
			"operation" : "add"
		   };

		   return Fetcher.post(formData.apiPath + '/api/obd/whitelist', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
			.then(res => {
				
				
				let whitelistAdded = false;
				if (res.message === 'Parameters Incorrect') {
					Notify.notify(res.message);
				} else {
					Notify.notify(res.message);
					whitelistAdded = true;
				}
				this.setState({
					whitelistAdded: whitelistAdded
				})
			})
			.catch(err => {
				console.log('Error in adding Whitelist', err);
				Notify.notify('Error in adding Whitelist');
			});
		}
		else if(this.state.formatType === "2"){
			
			const wlistFile = formData.wlistFileInput.current.files[0];
			const fd = new FormData();
			fd.append('wlistFile', wlistFile);
			fd.append('userId', this.state.userId);
			
			return Fetcher.post(formData.apiPath + '/api/obd/wlistupload', { method: 'POST', body: fd })
						.then(res => {
							let wlistUploaded = false;
							if (res.message === 'Parameters Incorrect!!') {
								Notify.notify(res.message);
							} else {
								Notify.notify(res.message);
								wlistUploaded = true;
							}
							this.setState({
								whitelistAdded: wlistUploaded
								
							})
						})
						.catch(err => {
							console.log('Error in uploading Whitelist File!!', err);
						});
		}
	}

	addZero = (i) => {
		if (i < 10) {
			i = "0" + i;
		}
		return i;
	}

    checkFileSize = (event) => {
		let allowedSize = 1;
		if (event.target.name === 'newContactsFile') {
			allowedSize = 20;
		}

		let files = event.target.files
		let err = [];
		for (var x = 0; x < files.length; x++) {
			if (((files[x].size / 1024 / 1024).toFixed(2)) > allowedSize) {
				err[x] = files[x].size + ' is too large, please pick a smaller file\n';
			}
		};
		for (var z = 0; z < err.length; z++) {
			event.target.value = null;
		}
		return true;
	}


    getFileNameFromUrl = (url) => {
		var n = url.lastIndexOf('/');
		return url.substring(n + 1);
	}

	checkMimeType = (event) => {
		let files = event.target.files
		let allowedTypes = ['text/plain', 'text/csv'];
		if (event.target.name === 'newContactsFile') {
			allowedTypes = ['text/plain', 'text/csv'];
		}
		let err = [] // create empty array

		for (var x = 0; x < files.length; x++) {
			if (allowedTypes.every(type => files[x].type !== type)) {
				err[x] = files[x].type + ' is not a supported format\n';
				// assign message to array
			}
		};
		for (var z = 0; z < err.length; z++) { // loop create toast massage
			event.target.value = null;
		}
		return true;
	}

    onFileChangeHandler = event => {
		//if ( this.checkMimeType( event ) && this.checkFileSize( event ) ) {
		if (this.checkMimeType(event)) {

		}
	}

	render() {
		if (this.state.whitelistAdded === true) {
			return <Redirect to='/view-whitelist' />
		}
		let submitButtonlabel = 'Add to Whitelist';

		return (

			<Form className="add-campaign-form" onSubmit={(e) => this.handleAddVoiceWhitelist(e)}>
				<Row>
					<Col sm={12}>
						<Card>
							<Card.Header>Add Number to Whitelist</Card.Header>
							<Card.Body>
								<Row>
                                    {(this.state.formatType === "1") && <>
									<Col sm={4}>
										<Form.Group className="form-group"  controlId="plan-name">
											<Form.Label>Mobile No.</Form.Label>
											<Form.Control required name="mobile" onChange={e => this.setvalue(e)} value={this.state.mobile} type="number" placeholder="Mobile No." />
										</Form.Group>
									</Col>
                                    </>
                                    }
                                    {(this.state.formatType === "2") && <>
                                    <Col sm={6}>
                                        <Form.Label>Upload File(.txt OR .csv format only)</Form.Label>
                                        <Form.Group className="form-group" controlId="whitelist-file-upload">
                                            <Form.Control required name="whitelistFile" onChange={this.onFileChangeHandler} ref={this.wlistFileInput} type="file" />
                                        </Form.Group>
                                    </Col>
                                    </>
                                    }


                                    <Col sm={4}>
                                        <Form.Group className="form-group required control-label">
                                            <Form.Label>Format Type</Form.Label>
                                            <Form.Select className="dd" required name="formatType" onChange={e => this.setvalue(e)} as="select">
                                                <option value="1">Individual</option>
                                                <option value="2">File</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
								</Row>
								<Button variant="primary" type="submit">{submitButtonlabel}</Button>
							</Card.Body>
						</Card>

					</Col>
				</Row>
			</Form>
		);
	}
}

export default AddWhitelist;